import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/announcement",
    name: "HomeAnno",
    component: Home,
  },
]

const router = new VueRouter({
  // 这里只能使用 hash 模式，否则在基于cdn+存储桶的站点下，无法直接使用 url 打开页面
  // mode: "history",
  routes,
})

export default router
